import { useSelector } from 'react-redux';

import { selectResources } from '@/reducers/common/selectors';

const useSocialMediaFormResources = () => {
  const resources = useSelector(selectResources);

  return {
    firstNameHeading: resources['SignUpForm.firstname'] ?? 'First name',
    lastnameHeading: resources['SignUpForm?.lastname'] ?? 'Last name',
    emailHeading: resources['SignUpForm.email'] ?? 'Email',
    dobHeading: resources['SignUpForm?.dob'] ?? 'Date of birth',
    signupContinue: 'Continue',
  };
};

export default useSocialMediaFormResources;
